<template>
  <div class="admin-create-order">
    <v-card class="create-order-success" elevation="0">
      <div class="success-logo">
        <v-icon size="124" color="#1a8e18">mdi-check-circle-outline </v-icon>
      </div>
      <v-card-text>
        <strong style="color: #1a8e18"
          >¡Pedido realizado correctamente a la mesa {{ tableQr }}!</strong
        >
      </v-card-text>
      <v-card-text
        ><strong>Total: {{ formatPrice(totalPrice) }} </strong></v-card-text
      >
      <v-card-text>El numero de pedido es el 45112233</v-card-text>
      <v-card-actions>
        <v-row>
          <v-col align="center">
            <div>
              <router-link to="/admin/orders/create-order">
                <button class="admin-navigation-back">
                  Crear pedido
                </button>
              </router-link>
            </div>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      totalPrice: 0,
      orderNumber: 1,
      tableQr: ""
    };
  },
  created() {
    this.totalPrice = this.$route.query ? this.$route.query.totalPrice : 0;
    this.orderNumber = this.$route.query ? this.$route.query.orderNumber : 0;
  },
  mounted() {
    this.tableQr = localStorage.getItem("adminTableQR");
    localStorage.removeItem("adminTableQR");
    this.$store.state.adminTableQR = "";
    localStorage.removeItem("admincart");
    localStorage.removeItem("admin-general-comment");
  }
};
</script>
